import { useParams } from "react-router-dom";
import ClassPage from "pages/store/class/Class";
import ShoppingPage from "pages/store/product/Product";
import TourCalendarPage from "pages/store/tour/TourCalendar";
const CategoryWrap = () => {
    const { category } = useParams();

    // 컴포넌트(<List />)로 렌더하면 매 렌더마다 함수 identity가 바뀌어
    // 하위 페이지가 언마운트/리마운트된다. 엘리먼트를 직접 반환해 리마운트를 막는다.
    const renderPage = () => {
        switch (category) {
            case "class":
                return <ClassPage />;
            case "shopping":
                return <ShoppingPage />;
            // case "tour":
            //     return <TourCalendarPage />;
            default:
                return <div>존재하지 않는 카테고리입니다.</div>;
        }
    };
    return <div>{renderPage()}</div>;
};

export default CategoryWrap;
